// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__21SNb","selected":"Chip_selected__1t-UK"};